import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import type { AccessCentreRoleByIdApiResponse } from 'domains/accessCentre/types';

const useGetRoleById = (
    roleId: number | string,
    reactQueryOptions?: UseQueryOptions<AccessCentreRoleByIdApiResponse, Error>
) =>
    useQuery<AccessCentreRoleByIdApiResponse>(
        QueryKeys.ACCESS_CENTRE_ROLE_ID(roleId),
        new PathWithID(CuredApiPaths.ACCESS_CENTRE_ROLES, roleId),
        { enabled: Boolean(roleId), ...reactQueryOptions }
    );

export default useGetRoleById;
